import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-whygovttowauction',
    templateUrl: 'whygovttowauction.component.html',
    styleUrls: ['whygovttowauction.component.css'],
    standalone: false
})
export class WhyGovtTowAuctionComponent implements AfterViewInit {
    message: any;
    constructor() { }
    ngOnInit() {
    }

    ngAfterViewInit(): void {
        let el = document.querySelector('.toptoscroll');
        el.scrollIntoView({behavior:"smooth"});
    }
}  